var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "10px",
  height: "8px",
  viewBox: "0 0 12 8",
  xmlns: "http://www.w3.org/2000/svg",
  className: "arrow-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-2, -4.04688)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  className: "arrow-down-path",
  fill: "currentColor",
  d: "M7.99893219,9.58712916 L3.70730528,5.29309177 C3.31689064,4.90245785 2.68372569,4.90228009 2.29309177,5.29269472 C1.90245785,5.68310936 1.90228009,6.31627431 2.29269472,6.70690823 L7.29122997,11.708251 C7.68164465,12.098885 8.31480969,12.0990627 8.70544359,11.7086479 L13.7095939,6.70730517 C14.1002277,6.31689047 14.1004054,5.68372552 13.7099907,5.29309166 C13.319576,4.9024578 12.6864111,4.90228014 12.2957772,5.29269483 L7.99893219,9.58712916 Z"
}))));
export default SvgArrowDown;